export let PhoneNumberSources;
(function (PhoneNumberSources) {
  PhoneNumberSources["CONNECT_NUMBER"] = "connect";
  PhoneNumberSources["EXTERNAL_NUMBER"] = "external";
  PhoneNumberSources["HUBSPOT_NUMBER"] = "hubspot";
})(PhoneNumberSources || (PhoneNumberSources = {}));